import { render } from "./ContatoComponent.vue?vue&type=template&id=4057d750&scoped=true"
import script from "./ContatoComponent.vue?vue&type=script&lang=js"
export * from "./ContatoComponent.vue?vue&type=script&lang=js"

import "./ContatoComponent.vue?vue&type=style&index=0&id=4057d750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4057d750"]])

export default __exports__